import { IconProps } from './IconProps';

export const InsightsIcon = ({
  className,
  style,
  fill = 'black',
  width = 14,
  height = 14,
}: {
  className?: string;
  style?: Record<string, unknown>;
  fill?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      className={className}
      style={style}
    >
      <path
        d="M6.70898 1.12891C7.09195 1.12894 7.46588 1.16765 7.82715 1.24121C7.54291 1.57736 7.32067 1.96751 7.17871 2.39453C7.0244 2.3779 6.8677 2.36916 6.70898 2.36914C4.31325 2.36932 2.37147 4.31135 2.37109 6.70703C2.37109 9.10303 4.31302 11.0457 6.70898 11.0459C7.88595 11.0458 8.95277 10.5765 9.73438 9.81543C9.74757 9.79925 9.76031 9.78168 9.77539 9.7666C9.78978 9.75224 9.8059 9.74019 9.82129 9.72754C10.5252 9.00214 10.9777 8.03218 11.0391 6.95703C11.4873 6.88779 11.9072 6.73403 12.2822 6.51172C12.2845 6.57657 12.2871 6.64164 12.2871 6.70703C12.2871 8.02196 11.8305 9.23004 11.0693 10.1836L13.3486 12.4629L13.4277 12.5605C13.5862 12.8009 13.5599 13.1281 13.3486 13.3398C13.137 13.5515 12.8099 13.5774 12.5693 13.4189L12.4717 13.3398L10.1934 11.0615C9.2386 11.8267 8.02766 12.285 6.70898 12.2852C3.62842 12.285 1.13086 9.78764 1.13086 6.70703C1.13123 3.62674 3.62865 1.12908 6.70898 1.12891Z"
        fill={fill}
      />
      <path
        d="M13.4582 3.46655C11.7672 4.02501 11.2035 4.58869 10.6443 6.28048C10.5987 6.41953 10.4021 6.41953 10.3557 6.28048C9.79726 4.58942 9.23357 4.02578 7.54179 3.46655C7.40274 3.42095 7.40274 3.22433 7.54179 3.17798C9.23284 2.61952 9.79649 2.05584 10.3557 0.364055C10.4013 0.225003 10.5979 0.225003 10.6443 0.364055C11.2027 2.05511 11.7664 2.61875 13.4582 3.17798C13.5973 3.22358 13.5973 3.4202 13.4582 3.46655Z"
        fill={fill}
      />
    </svg>
  );
};

